<template>
  <ContextMenuPortal>
    <ContextMenuContent
      :collision-padding="10"
      :class="[
        $style.container,
        `z-popover flex max-h-[80dvh] flex-col overflow-y-auto rounded-md border-menu-border bg-menu p-2 text-menu-foreground shadow-lg transition dark:border`,
      ]"
    >
      <slot />
    </ContextMenuContent>
  </ContextMenuPortal>
</template>

<script setup lang="ts">
import { ContextMenuContent, ContextMenuPortal } from "reka-ui";
</script>

<style module>
.container {
  transform-origin: var(--reka-context-menu-content-transform-origin);

  @media (prefers-reduced-motion: no-preference) {
    &[data-state="open"] :global {
      animation: pop-in 250ms var(--motion-timing-ease);
    }
    &[data-state="closed"] :global {
      animation: pop-out 250ms var(--motion-timing-ease);
    }
  }
}
</style>
